import { schema } from 'normalizr';

const examSchema = {
  exam: new schema.Entity('exams'),
  completeExamSolution: new schema.Entity('completeExamSolutions'),
  examSolutionNestedInQuestion: new schema.Entity('solutionsByQuestionId'),
  examSection: new schema.Entity('examSections'),
  examQuestion: new schema.Entity('examQuestions'),
  sitting: new schema.Entity('sittingsByExamId', {}, { idAttribute: 'exam' }),
  response: new schema.Entity(
    'responsesByQuestionId',
    {},
    { idAttribute: 'question' }
  ),
  checklistQuestionProgress: new schema.Entity(
    'checklistQuestionProgress',
    {},
    {
      idAttribute: 'question',
    }
  ),
  checklistResponse: new schema.Entity('checklistResponses'),
  checklistReflection: new schema.Entity('checklistReflection'),
};

examSchema.exam.define({
  sections: new schema.Array(examSchema.examSection),
});
examSchema.completeExamSolution.define({
  questions: new schema.Array(examSchema.examSolutionNestedInQuestion),
});
examSchema.examSection.define({
  questions: new schema.Array(examSchema.examQuestion),
});
examSchema.examQuestion.define({
  children: new schema.Array(examSchema.examQuestion),
});

examSchema.sitting.define({
  responses: new schema.Array(examSchema.response),
});

examSchema.checklistQuestionProgress.define({
  responses: new schema.Array(examSchema.checklistResponse),
});

export default examSchema;
